import { useUserTranslation } from "@/common/composables/user-translation";
export default {
    install: (app) => {
        const { $u } = useUserTranslation();
        app.config.globalProperties.$u = $u;
        app.provide("$u", $u);
    }
};
